import clsx from 'clsx'
import type { CSSProperties } from 'react'

import s from './Skeleton.module.css'

interface SkeletonProps {
  width?: number | string
  height?: number | string
  className?: string
  style?: CSSProperties
}

export function Skeleton({ width = '100%', height = 14, className, style }: SkeletonProps) {
  return (
    <span
      className={clsx(s.skeleton, className)}
      style={{ width, height, ...style }}
      aria-hidden="true"
    />
  )
}
